import { render, staticRenderFns } from "./menu_icon_adjustment_parcel_point.vue?vue&type=template&id=2cc2f382&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports